import "./DashboardVariable.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import DropDown from "/src/components/UI/DropDown/DropDown";
function DashboardDropdown({ data, postbackAction}) {
    var choices = data.placeholder_format.split("|");
    var switchTimer;
    var arrayChoices = [];
    for (var i = 0; i < choices.length; i++) {
        arrayChoices.push(
            {
                value: i,
                text: <span>{choices[i]} </span> 
            },
        )
    }
    const saveData = (value) => {
        clearTimeout(switchTimer);
        switchTimer = setTimeout(() => {
            postbackAction(value);
        }, 1500);
    }
    return (
        <div >
            <DropDown choices={arrayChoices} width="220px" defaultChoice={data.value} setValue={(name,value) => saveData(value)}></DropDown>
        </div>
    );
}

export default DashboardDropdown;